export const PASS_WORD = '请输入7-16位，数字,字母,特殊符号组合'
